import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
// data-factory 模块已弃用，所有导入暂时禁用
// import { geoGrowthRoutes } from '@/views/data-factory/geo-growth-df/router-config'
// import { diagnosisRoutes } from '@/views/data-factory/diagnosis-df/router-config'
// import contentRoutes from '@/views/data-factory/content generation-df/router-config'
// import { knowledgeRoutes } from '@/views/data-factory/knowledge-df/router-config'
// import { toolSquareRoutes } from '@/views/data-factory/tool-square-df/router-config'
// import { serviceMarketRoutes } from '@/views/data-factory/service-market-df/router-config'
// import { customRoutes } from '@/views/data-factory/custom-df/router-config'
// import { vendorRoutes } from '@/views/data-factory/vendor-df/router-config'
// [V32归档] import { businessRoutes } from '@/views/business-site/router-config'
import { vendorSiteRoutes } from '@/views/vendor-site/router-config'
import { partnerRoutes } from '@/views/partner-site/router-config'
import { appRoutes } from '@/views/partner-app'
import { toolboxRoutes } from '@/views/toolbox-site/router-config'
import { workflowRoutes } from '@/views/workflow-site/router-config'
import { expertRoutes } from '@/views/expert-site/router-config'
// [V8.2 v2.1 2026-09-08] 三农官网独立构建 — 重命名目录 + 启用路由
import { sannongRoutes } from '@/views/sannong-site/router-config'
// 旧 autoSiteRoutes 仍按 below 占位（auto-site 路由 2026-08-04 已删，未来如需启用 automation-site 改回 import）
const autoSiteRoutes: RouteRecordRaw[] = []
import { agentSiteRoutes } from '@/views/agent-site/router-config'
import { platformRoutes } from '@/views/platform'
import { businessSiteV2Routes } from '@/views/business-site-v2'
import { operationRoutes } from '@/views/operation-site/router-config'

import { salesAdminRouteConfig } from '@/views/sales-admin/router-config'

// Trust域组件 - data-factory 模块已弃用，路由暂时禁用
// const TrustDashboard = () => import('@/views/data-factory/trust asset-df/TrustDashboard.vue')
// const TrustPassport = () => import('@/views/data-factory/trust asset-df/passport/List.vue')
// const TrustScore = () => import('@/views/data-factory/trust asset-df/score/Dashboard.vue')
// const SentimentMonitor = () => import('@/views/data-factory/trust asset-df/sentiment/Monitor.vue')

// User-center域组件 - data-factory 模块已弃用，暂时禁用
// const UserCenter = () => import('@/views/data-factory/business-user-df/UserCenter.vue')
// const BusinessManagement = () => import('@/views/data-factory/business-user-df/enterprise/BusinessManagement.vue')
// const BrandDashboard = () => import('@/views/data-factory/business-user-df/dashboard/BrandDashboard.vue')

// [V8.2] AI 官网 — 全新重写（独立于 business-site-v2）
const aiOfficialSiteRoutes: RouteRecordRaw[] = [
  {
    path: '/ai-site',
    name: 'AiOfficialSite',
    component: () => import('../views/ai-official-site/views/AiSiteLayout.vue'),
    meta: {
      title: 'AI官网',
      permissions: ['platform_business:ai_site:view'],
    },
    children: [
      {
        path: '',
        name: 'AiSiteDashboard',
        component: () => import('../views/ai-official-site/views/SiteDashboard.vue'),
      },
      {
        path: 'editor/:siteId?',
        name: 'AiSiteEditor',
        component: () => import('../views/ai-official-site/views/SiteEditor.vue'),
      },
      {
        path: 'history',
        name: 'AiSiteHistory',
        component: () => import('../views/ai-official-site/views/SiteHistory.vue'),
      },
      {
        path: 'preview/:siteId',
        name: 'AiSitePreview',
        component: () => import('../views/ai-official-site/views/SitePreview.vue'),
      },
    ],
  },
]

const routes: RouteRecordRaw[] = [
  // data-factory 模块已弃用
  // ...knowledgeRoutes,
  // ...toolSquareRoutes,
  // ...serviceMarketRoutes,
  // ...customRoutes,
  // ...vendorRoutes,
  // [V32归档] ...businessRoutes,
  // [V8.8.2] 按 VITE_PLATFORM 过滤路由（独立构建时只加载该平台路由）
  // 全量构建（VITE_PLATFORM 未设或 = all）时加载全部
  // 独立构建（expert-site / partner-site / vendor-site / operation-site / platform-site / sales-admin）只加载对应平台路由
  ...(import.meta.env.VITE_PLATFORM === 'vendor-site'   ? vendorSiteRoutes   : []),
  ...(import.meta.env.VITE_PLATFORM === 'partner-site'  ? partnerRoutes      : []),
  ...(import.meta.env.VITE_PLATFORM === 'expert-site'    ? expertRoutes       : []),
  ...(import.meta.env.VITE_PLATFORM === 'operation-site' ? operationRoutes    : []),
  ...(import.meta.env.VITE_PLATFORM === 'platform-site'  ? platformRoutes    : []),
  ...(import.meta.env.VITE_PLATFORM === 'sales-admin'    ? [salesAdminRouteConfig.layout] : []),
  ...(import.meta.env.VITE_PLATFORM === 'sannong-site'   ? sannongRoutes     : []),
  // V8.8.6 2026-09-12 修复 dev 模式栈溢出：补 business-site + ai-official-site 分支
  // 之前缺这两个分支 → VITE_PLATFORM=business-site 时所有平台 routes 都不加载
  // → main routes 只剩 catch-all redirect '/' → 死循环 → Maximum call stack size exceeded
  ...(import.meta.env.VITE_PLATFORM === 'business-site'    ? businessSiteV2Routes : []),
  ...(import.meta.env.VITE_PLATFORM === 'ai-official-site' ? aiOfficialSiteRoutes  : []),
  ...((!import.meta.env.VITE_PLATFORM || import.meta.env.VITE_PLATFORM === 'all') ? [
    ...vendorSiteRoutes,
    ...partnerRoutes,
    ...expertRoutes,
    ...operationRoutes,
    ...platformRoutes,
    salesAdminRouteConfig.layout,
    ...appRoutes,
    ...toolboxRoutes,
    ...workflowRoutes,
    ...sannongRoutes,
    ...agentSiteRoutes,
    ...autoSiteRoutes,
    ...businessSiteV2Routes,
    ...aiOfficialSiteRoutes,
  ] : []),
  {
    path: '/text-similarity',
    redirect: '/content'
  },
  // [评价获取助手 F-P1-2] 客户确认 H5 — 公开路由（契约 §4.1 URL 约定 {FE_BASE}/r/{token}）。
  // 顶层注册（不进 aiOfficialSiteRoutes）：客户直达页面不受 VITE_PLATFORM 构建过滤，
  // token 即凭证（契约 §5：公开端点免登录），requiresAuth: false 放行全局登录守卫。
  {
    path: '/r/:token',
    name: 'ReviewConfirm',
    component: () => import('../views/ai-official-site/views/public/ReviewConfirmPage.vue'),
    meta: { requiresAuth: false, title: '评价确认' },
  },
  // [评价获取助手 F-P1-9] H5 扫码起草 — 公开路由（契约 §4.1 URL 约定 {FE_BASE}/invite/{code}）。
  // invite_code 非凭证级秘密（张贴物料本就公开），404 统一口径防探测轮换态。
  {
    path: '/invite/:code',
    name: 'ReviewInvite',
    component: () => import('../views/ai-official-site/views/public/ReviewInvitePage.vue'),
    meta: { requiresAuth: false, title: '邀您评价' },
  },
  // data-factory 模块已弃用 — 所有相关路由已禁用
  // {
  //   path: '/geo-growth',
  //   redirect: '/data-factory/geo-growth'
  // },
  // {
  //   path: '/diagnosis',
  //   name: 'Diagnosis',
  //   component: () => import('@/views/data-factory/diagnosis-df/dashboard.vue'),
  //   meta: { title: '诊断服务', permissions: ['diagnosis_view'] }
  // },

  // Trust域 - 信任资产 (data-factory 模块已弃用，暂时禁用)
  /*
  {
    path: '/trust',
    name: 'TrustDashboard',
    component: TrustDashboard,
    meta: { title: '信任资产', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/overview',
    name: 'TrustOverview',
    component: () => import('@/views/data-factory/trust asset-df/overview/TrustOverview.vue'),
    meta: { title: '信任概览', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/passport',
    name: 'TrustPassport',
    component: TrustPassport,
    meta: { title: '信任护照', permissions: ['trust_passport_view'] }
  },
  {
    path: '/trust/passport/:id',
    name: 'TrustPassportDetail',
    component: () => import('@/views/data-factory/trust asset-df/passport/Detail.vue'),
    meta: { title: '信任护照详情', permissions: ['trust_passport_view'] }
  },
  {
    path: '/trust/passport/list',
    name: 'PassportList',
    component: () => import('@/views/data-factory/trust asset-df/passport/List.vue'),
    meta: { title: '信任护照列表', permissions: ['trust_passport_view'] }
  },
  {
    path: '/trust/score',
    name: 'TrustScore',
    component: TrustScore,
    meta: { title: '信用分', permissions: ['trust_score_view'] }
  },
  {
    path: '/trust/score/detail',
    name: 'TrustScoreDetail',
    component: () => import('@/views/data-factory/trust asset-df/score/Detail.vue'),
    meta: { title: '信用分详情', permissions: ['trust_score_view'] }
  },
  {
    path: '/trust/sentiment',
    name: 'SentimentMonitor',
    component: SentimentMonitor,
    meta: { title: '舆情监控', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/sentiment/analysis',
    name: 'SentimentAnalysis',
    component: () => import('@/views/data-factory/trust asset-df/sentiment/Analysis.vue'),
    meta: { title: '舆情分析', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/sentiment/history',
    name: 'SentimentHistory',
    component: () => import('@/views/data-factory/trust asset-df/sentiment/SentimentHistory.vue'),
    meta: { title: '舆情历史', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/assets',
    name: 'AssetList',
    component: () => import('@/views/data-factory/trust asset-df/assets/AssetList.vue'),
    meta: { title: '信任资产列表', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/assets/:id',
    name: 'AssetDetail',
    component: () => import('@/views/data-factory/trust asset-df/assets/AssetDetail.vue'),
    meta: { title: '资产详情', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/assets/dashboard',
    name: 'AssetDashboard',
    component: () => import('@/views/data-factory/trust asset-df/assets/AssetDashboard.vue'),
    meta: { title: '资产看板', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/assets/create',
    name: 'AssetCreate',
    component: () => import('@/views/data-factory/trust asset-df/assets/AssetCreate.vue'),
    meta: { title: '创建资产', permissions: ['trust_asset_manage'] }
  },
  {
    path: '/trust/assets/:id/edit',
    name: 'AssetEdit',
    component: () => import('@/views/data-factory/trust asset-df/assets/AssetEdit.vue'),
    meta: { title: '编辑资产', permissions: ['trust_asset_manage'] }
  },
  {
    path: '/trust/endorsement',
    name: 'EndorsementList',
    component: () => import('@/views/data-factory/trust asset-df/endorsement/EndorsementList.vue'),
    meta: { title: '背书列表', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/endorsement/:id',
    name: 'EndorsementDetail',
    component: () => import('@/views/data-factory/trust asset-df/endorsement/EndorsementDetail.vue'),
    meta: { title: '背书详情', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/endorsement/create',
    name: 'EndorsementCreate',
    component: () => import('@/views/data-factory/trust asset-df/endorsement/EndorsementCreate.vue'),
    meta: { title: '创建背书', permissions: ['trust_asset_manage'] }
  },
  {
    path: '/trust/endorsement/review',
    name: 'EndorsementReview',
    component: () => import('@/views/operation-site/pages/ops-trust/EndorsementReview.vue'),
    meta: { title: '背书审核', permissions: ['trust_asset_manage'] }
  },
  {
    path: '/trust/score/rules',
    name: 'TrustScoreRules',
    component: () => import('@/views/data-factory/trust asset-df/score/Rules.vue'),
    meta: { title: '信任分规则', permissions: ['trust_score_view'] }
  },
  {
    path: '/trust/score/monitor',
    name: 'TrustScoreMonitor',
    component: () => import('@/views/data-factory/trust asset-df/score/Monitor.vue'),
    meta: { title: '信任分监控', permissions: ['trust_score_view'] }
  },
  {
    path: '/trust/public/monitor',
    name: 'PublicMonitor',
    component: () => import('@/views/data-factory/trust asset-df/public/Monitor.vue'),
    meta: { title: '公域监控', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/trend',
    name: 'TrendChart',
    component: () => import('@/views/data-factory/trust asset-df/trend/TrendChart.vue'),
    meta: { title: '趋势分析', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/trend/history',
    name: 'TrendHistory',
    component: () => import('@/views/data-factory/trust asset-df/trend/TrendHistory.vue'),
    meta: { title: '趋势历史数据', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/trend/prediction',
    name: 'TrendPrediction',
    component: () => import('@/views/data-factory/trust asset-df/trend/TrendPrediction.vue'),
    meta: { title: '趋势预测分析', permissions: ['trust_asset_view'] }
  },
  {
    path: '/trust/trend/comparison',
    name: 'TrendComparison',
    component: () => import('@/views/data-factory/trust asset-df/trend/TrendComparison.vue'),
    meta: { title: '数据对比分析', permissions: ['trust_asset_view'] }
  },
  */
  // User-center域 - data-factory 模块已弃用，暂时禁用
  /*
  {
    path: '/user-center',
    name: 'UserCenter',
    component: UserCenter,
    meta: { title: '用户中心', permissions: ['user_view'] }
  },
  {
    path: '/user-center/users',
    name: 'UserList',
    component: () => import('@/views/data-factory/business-user-df/UserList.vue'),
    meta: { title: '用户列表', permissions: ['user_view'] }
  },
  {
    path: '/user-center/users/:id',
    name: 'UserDetail',
    component: () => import('@/views/data-factory/business-user-df/UserDetail.vue'),
    meta: { title: '用户详情', permissions: ['user_view'] }
  },
  {
    path: '/user-center/users/create',
    name: 'UserCreate',
    component: () => import('@/views/data-factory/business-user-df/users/UserCreate.vue'),
    meta: { title: '创建用户', permissions: ['user_manage'] }
  },
  {
    path: '/user-center/users/:id/edit',
    name: 'UserEdit',
    component: () => import('@/views/data-factory/business-user-df/users/UserEdit.vue'),
    meta: { title: '编辑用户', permissions: ['user_manage'] }
  },
  {
    path: '/user-center/business',
    name: 'BusinessManagement',
    component: BusinessManagement,
    meta: { title: '业务管理', permissions: ['business_view'] }
  },
  {
    path: '/user-center/business/list',
    name: 'BusinessList',
    component: () => import('@/views/data-factory/business-user-df/enterprise/BusinessList.vue'),
    meta: { title: '业务列表', permissions: ['business_view'] }
  },
  {
    path: '/user-center/business/:id',
    name: 'BusinessDetail',
    component: () => import('@/views/data-factory/business-user-df/enterprise/BusinessDetail.vue'),
    meta: { title: '业务详情', permissions: ['business_view'] }
  },
  {
    path: '/user-center/business/create',
    name: 'BusinessCreate',
    component: () => import('@/views/data-factory/business-user-df/enterprise/BusinessCreate.vue'),
    meta: { title: '创建业务', permissions: ['business_manage'] }
  },
  {
    path: '/user-center/business/:id/edit',
    name: 'BusinessEdit',
    component: () => import('@/views/data-factory/business-user-df/enterprise/BusinessEdit.vue'),
    meta: { title: '编辑业务', permissions: ['business_manage'] }
  },
  {
    path: '/user-center/business/:id/members',
    name: 'MemberManage',
    component: () => import('@/views/data-factory/business-user-df/enterprise/MemberManage.vue'),
    meta: { title: '成员管理', permissions: ['business_manage'] }
  },
  {
    path: '/user-center/dashboard',
    name: 'BrandDashboard',
    component: BrandDashboard,
    meta: { title: '品牌看板', permissions: ['user_view'] }
  },
  {
    path: '/user-center/dashboard/trend',
    name: 'BrandTrend',
    component: () => import('@/views/data-factory/business-user-df/dashboard/BrandTrend.vue'),
    meta: { title: '品牌趋势', permissions: ['user_view'] }
  },
  {
    path: '/user-center/dashboard/:id',
    name: 'BrandDetail',
    component: () => import('@/views/data-factory/business-user-df/dashboard/BrandDetail.vue'),
    meta: { title: '品牌详情', permissions: ['user_view'] }
  },
  {
    path: '/user-center/dashboard/ranking',
    name: 'BrandRanking',
    component: () => import('@/views/data-factory/business-user-df/dashboard/BrandRanking.vue'),
    meta: { title: '品牌排名', permissions: ['user_view'] }
  },
  {
    path: '/user-center/dashboard/summary',
    name: 'BrandSummary',
    component: () => import('@/views/data-factory/business-user-df/dashboard/BrandSummary.vue'),
    meta: { title: '数据汇总', permissions: ['user_view'] }
  },
  {
    path: '/user-center/dashboard/evaluation',
    name: 'BrandEvaluation',
    component: () => import('@/views/data-factory/business-user-df/dashboard/BrandEvaluation.vue'),
    meta: { title: '效果评估', permissions: ['user_view'] }
  },
  {
    path: '/user-center/tasks',
    name: 'TaskList',
    component: () => import('@/views/data-factory/business-user-df/tasks/TaskList.vue'),
    meta: { title: '任务列表', permissions: ['user_view'] }
  },
  {
    path: '/user-center/tasks/:id',
    name: 'TaskDetail',
    component: () => import('@/views/data-factory/business-user-df/tasks/TaskDetail.vue'),
    meta: { title: '任务详情', permissions: ['user_view'] }
  },
  {
    path: '/user-center/tasks/create',
    name: 'TaskCreate',
    component: () => import('@/views/data-factory/business-user-df/tasks/TaskCreate.vue'),
    meta: { title: '创建任务', permissions: ['user_view'] }
  },
  {
    path: '/user-center/tasks/:id/assign',
    name: 'TaskAssign',
    component: () => import('@/views/data-factory/business-user-df/tasks/TaskAssign.vue'),
    meta: { title: '分配任务', permissions: ['user_manage'] }
  },
  {
    path: '/user-center/plans',
    name: 'PlanList',
    component: () => import('@/views/data-factory/business-user-df/plans/PlanList.vue'),
    meta: { title: '计划列表', permissions: ['user_view'] }
  },
  {
    path: '/user-center/plans/:id',
    name: 'PlanDetail',
    component: () => import('@/views/data-factory/business-user-df/plans/PlanDetail.vue'),
    meta: { title: '计划详情', permissions: ['user_view'] }
  },
  {
    path: '/user-center/plans/create',
    name: 'PlanCreate',
    component: () => import('@/views/data-factory/business-user-df/plans/PlanCreate.vue'),
    meta: { title: '创建计划', permissions: ['user_view'] }
  },
  {
    path: '/user-center/plans/:id/track',
    name: 'PlanTrack',
    component: () => import('@/views/data-factory/business-user-df/plans/PlanTrack.vue'),
    meta: { title: '跟踪计划', permissions: ['user_view'] }
  },
  {
    path: '/user-center/analytics',
    name: 'DataAnalysis',
    component: () => import('@/views/data-factory/business-user-df/analytics/DataAnalysis.vue'),
    meta: { title: '数据分析', permissions: ['user_view'] }
  },
  {
    path: '/user-center/analytics/trend',
    name: 'TrendAnalysis',
    component: () => import('@/views/data-factory/business-user-df/analytics/TrendAnalysis.vue'),
    meta: { title: '趋势分析', permissions: ['user_view'] }
  },
  {
    path: '/user-center/analytics/effect',
    name: 'EffectEvaluation',
    component: () => import('@/views/data-factory/business-user-df/analytics/EffectEvaluation.vue'),
    meta: { title: '效果评估', permissions: ['user_view'] }
  },
  */
  // GEO优化增长域 - data-factory 模块已弃用
  // ...geoGrowthRoutes,
  // Diagnosis域 - data-factory 模块已弃用
  // ...diagnosisRoutes,
  // Content域 - data-factory 模块已弃用
  // ...contentRoutes,
  
  // [V32归档] 测试路由 - 旧 business-site 调试用，V2 完成后删除
  // {
  //   path: '/test-business-route',
  //   name: 'TestBusinessRoute',
  //   component: () => import('@/views/business-site/pages/Dashboard.vue'),
  //   meta: { title: '测试路由' }
  // }

  // ── catch-all 兜底路由：所有未匹配路径重定向到首页 ──
  // 企业级标准：避免未匹配路由导致白屏，统一引导到首页
  // 常见触发场景：浏览器历史记录残留旧 URL、书签过期、手动输错路径
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundCatchAll',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 权限守卫 - 开发模式：暂时禁用严格权限检查
// const v6PermissionGuard = createV6PermissionGuard()
// router.beforeEach(v6PermissionGuard)

// 导航守卫：设置文档标题 + sales-admin 平台 token 检查 + 全局登录守卫
router.beforeEach(async (to) => {
  // sales-admin 平台：未登录强制跳到 /login（避免无限 redirect 嵌套）
  if (import.meta.env.VITE_PLATFORM === 'sales-admin') {
    const hasToken = !!localStorage.getItem('access_token')
    if (!hasToken && to.path !== '/login') {
      // 用 to.path 不用 to.fullPath，避免 query 参数嵌套
      return { path: '/login', query: { redirect: to.path } }
    }
    // 已登录访问 /login → 跳 sales-admin 首页（/team-dashboard，不是 /dashboard）
    if (hasToken && to.path === '/login') {
      return { path: '/team-dashboard' }
    }
  }

  // 全局登录守卫（V8.8.4 2026-09-11 新增）
  // 适用：除 sales-admin 外的所有平台（sales-admin 已有独立守卫在上面）
  if (import.meta.env.VITE_PLATFORM !== 'sales-admin') {
    const hasToken = !!(
      localStorage.getItem('access_token')
      || localStorage.getItem('bs2_access_token')
      || localStorage.getItem('dt_auth_token')
    )
    const isLoginRoute = to.path === '/login' || to.path === '/platform/login'
    const requiresAuth = to.meta.requiresAuth !== false  // 默认 true，显式 false 才放行

    if (!hasToken && !isLoginRoute && requiresAuth) {
      return { path: '/login', query: { redirect: to.fullPath } }
    }
    if (hasToken && isLoginRoute) {
      return { path: '/' }  // 已登录访问 /login → 跳默认页
    }
  }

  document.title = `${to.meta.title || 'DeepTrust'} - DeepTrust V7.2`
})

export default router
